import { AccountInfo } from '@azure/msal-browser';
import { BaseState, LoadingState } from '@core/utility/state';

export const identityStateKey = 'identity';

export interface IdentityState extends BaseState {
  account: AccountInfo | null;
  roles: any;
  user: any;
}

export const initialIdentityState: IdentityState = {
  account: null,
  user: null,
  requestState: LoadingState.INIT,
  roles: null,
};
